import { render, staticRenderFns } from "./ListMethodical.vue?vue&type=template&id=a31d02aa&scoped=true"
import script from "./ListMethodical.vue?vue&type=script&lang=ts"
export * from "./ListMethodical.vue?vue&type=script&lang=ts"
import style0 from "./ListMethodical.vue?vue&type=style&index=0&id=a31d02aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31d02aa",
  null
  
)

export default component.exports